import React, { Component } from "react";

class StoryAwait extends Component{
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }
    
    componentDidMount() {

    }
    componentWillUnmount() {
        
    }

    render(){
        return(
            <React.Fragment>

            </React.Fragment>
        )
    }
}
export default StoryAwait;
